import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { ReviewsList } from "@wojo/storyblok";
import { Text } from "@wojo/ui";
import { useId } from "react";
import { useTourCodes } from "../../_client/context";
import { TourSectionId } from "../../_client/hooks";
import styles from "./Reviews.module.scss";

export const Reviews: React.FC = () => {
    const headingId = useId();
    const { productPage } = useI18n("productPage");

    const tourCodes = useTourCodes();
    if (!tourCodes) {
        return null;
    }

    return (
        <section
            id={TourSectionId.REVIEWS}
            tabIndex={-1}
            aria-labelledby={headingId}
            className={styles.container}
        >
            <Text.Heading
                order="3"
                tag="h2"
                id={headingId}
                style={{ paddingBottom: "var(--g-spacing-sm)" }}
            >
                {productPage.reviews.heading.l()}
            </Text.Heading>
            <div className={styles.wrapper}>
                <ReviewsList
                    tourCode={{ value: tourCodes }}
                    reviewStyle="without-tour-name"
                    onSortChange={(sort) => {
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_object: "ELEMENT",
                                ga4_action: "SORTED",
                                elementType: "radio button",
                                elementID: "reviewSorter",
                                sortOption: sort,
                            },
                        });
                    }}
                    onSortModalOpened={() => {
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_object: "ELEMENT",
                                ga4_action: "CLICKED",
                                elementType: "modal",
                                elementID: "reviewSorter",
                            },
                        });
                    }}
                    onPagination={() => {
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_object: "ELEMENT",
                                ga4_action: "CLICKED",
                                elementType: "button",
                            },
                        });
                    }}
                />
            </div>
        </section>
    );
};
